const AsSeenOnLogos = () => {
  const logos = [
    { src: "/assets/images/house-competition/logo_thesun.svg", alt: "logo The Sun" },
    { src: "/assets/images/house-competition/logo_mirror.svg", alt: "logo The Mirror" },
    { src: "/assets/images/house-competition/logo_dailystar.svg", alt: "logo Masthead Dailystar" },
    { src: "/assets/images/house-competition/logo_express.svg", alt: "logo Express" },
    { src: "/assets/images/house-competition/logo_dailymail.svg", alt: "logo Daily Mail" },
    { src: "/assets/images/house-competition/logo_4.svg", alt: "logo All4" },
    { src: "/assets/images/house-competition/logo_sky.svg", alt: "logo Sky" },
  ];

  return (
    <div className={"flex flex-col items-center gap-3 lg:gap-6 font-jost"}>
      <div
        className={
          "self-stretch text-[#4C4C52] text-center text-[22px] lg:text-2xl font-normal leading-7 lg:leading-7.5 lg:uppercase"
        }>
        As seen on
      </div>
      <div
        className={
          "flex flex-wrap items-center justify-center max-lg:gap-x-8 max-lg:gap-y-2 lg:justify-between lg:w-full"
        }>
        {logos.map((logo, index) => (
          <div key={`Logo-${index}`} className="shrink-0 flex items-center justify-center">
            <img className={"shrink-0 w-auto h-8 lg:h-[38px]"} src={logo.src} width={120} height={48} alt={logo.alt} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default AsSeenOnLogos;
